import { Chip } from "@mui/material";
import type { ChipProps } from "@mui/material/Chip";
import { CrudLink, CustomCellDate } from "@/shared/components";
import type { ColumnDefinition } from "@/shared/components/CRUD/types";
import type { DataListViewColumns } from "@/shared/components/DataListView";
import { stepsSummary } from "./mappers";
import { PLAN_STATUS_LABELS } from "./schemas";
import type { AssistantPlanRow } from "./types";

const STATUS_COLORS: Record<string, ChipProps["color"]> = {
  DRAFT: "default",
  RUNNING: "info",
  DONE: "success",
  PARTIAL: "warning",
  FAILED: "error",
  CANCELLED: "default",
};

export const statusChip = (status: string) => (
  <Chip
    size="small"
    label={PLAN_STATUS_LABELS[status] ?? status}
    color={STATUS_COLORS[status] ?? "default"}
  />
);

export const getColumnsConfig = (): ColumnDefinition<AssistantPlanRow>[] => [
  { name: "id", label: "ID", options: { display: false, filter: false } },
  {
    name: "plan",
    label: "План",
    options: {
      sort: false,
      customBodyRender: (data: unknown) => {
        const row = data as AssistantPlanRow;
        return (
          <CrudLink id={row.id} tab="details">
            {row.title}
          </CrudLink>
        );
      },
    },
  },
  { name: "organization", label: "Организация", options: { sort: false } },
  { name: "user", label: "Сотрудник", options: { sort: false } },
  {
    name: "steps",
    label: "Шаги",
    options: {
      sort: false,
      customBodyRender: (data: unknown) =>
        stepsSummary((data as AssistantPlanRow).steps),
    },
  },
  {
    name: "status",
    label: "Статус",
    options: {
      sort: false,
      customBodyRender: (value: unknown) => statusChip(String(value)),
    },
  },
  {
    name: "createdAt",
    label: "Создан",
    options: {
      setCellHeaderProps: () => ({ style: { width: 150 } }),
      customBodyRender: (value: unknown) => (
        <CustomCellDate date={value as string} />
      ),
    },
  },
];

export const getMobileColumnsConfig =
  (): DataListViewColumns<AssistantPlanRow> => ({
    main: {
      title: "План",
      sx: { flex: 1, minWidth: 0 },
      renderCell: (row) => (
        <CrudLink id={row.id} tab="details" noWrap>
          {row.title}
        </CrudLink>
      ),
    },
    status: {
      title: "Статус",
      sx: { width: 110, flexShrink: 0 },
      renderCell: (row) => statusChip(row.status),
    },
  });

export const getTextsConfig = () => ({
  filterTitle: "Фильтры",
  listTitle: "Планы помощника",
  refetchList: "Обновить список",
  editItem: "План",
  showTitle: "План",
});
